import { HttpClient, HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import * as global from '../global';
import { API_URL } from "../../../environments/api-url";
import { DashboardService } from '../dashboard/dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class CertificationService {
  currentUser:any;
  constructor(
    authService: AuthService,
    private httpclient: HttpClient,
    private dashboardService: DashboardService
  ) {
    this.currentUser = authService.currentUser
  }
  
  uploadFilesForCertification(files: File, facility_id, provider_id, census_id): Observable<HttpEvent<any>> {
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      // title: file.name, 
      company_id: this.currentUser.company_id,
      facility_id: facility_id,
      census_id: census_id,
      provider_id: provider_id
    };
    const formData: FormData = new FormData();
    formData.append('files', files);

    for (let key of Object.keys(payload)) {
      formData.append(key, payload[key]);
    }

    const req = new HttpRequest('POST', global.url + API_URL.CERT.uploadFilesForCertification, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.httpclient.request(req);
  }

  // getFiles(): Observable<any> {
  //   return this.httpclient.get(`${this.baseUrl}/files`);
  // }

  extractData(census_id, provider_id, facility_id){
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      // title: file.name, 
      company_id: this.currentUser.company_id,
      census_id,
      provider_id, 
      facility_id
    };
    return this.httpclient.post(global.url + API_URL.CERT.extractData, {details: payload}).pipe()
  }
  checkData(facilityID, providerID, censusID){
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      facilityID: facilityID, 
      providerID: providerID, 
      censusID: censusID, 
      company_id: this.currentUser.company_id,
    };
    return this.httpclient.post(global.url + API_URL.CERT.checkData, {details: payload}).pipe()
  }
  checkCensus(facilityID, providerID){
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      facilityID: facilityID, 
      providerID: providerID, 
      company_id: this.currentUser.company_id,
    };
    return this.httpclient.post(global.url + API_URL.CERT.checkCensus, {details: payload}).pipe()
  }
  getMIPs(){
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      // title: file.name, 
      company_id: this.currentUser.company_id,
    };
    return this.httpclient.post(global.url + API_URL.CERT.getMIPs, {details: payload}).pipe()
  }
    generateReport(facility_id, provider_id, census_id, mip_id){
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      // title: file.name, 
      company_id: this.currentUser.company_id,
      provider_id,
      facility_id,
      mip_id,
      census_id
    };
    // return this.httpclient.post(global.url + API_URL.CERT.generateReport, {details: payload})
    const fileName = 'report.zip'
    this.dashboardService.downloadFile(global.url + API_URL.CERT.generateReport, payload).subscribe((res: any) => {
      if (res instanceof HttpResponse) {

          var url = window.URL.createObjectURL(res.body);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
      } else {

      }
  }, (err) => {
  },
      () => {
      })
    
  }

}
